<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="40%"
    class="addBudgetPerformancePermissionDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="budgetPerformancePermissionForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="费用部门名称" prop="deptCode">
            <el-select
              v-model="formData.deptCode"
              clearable
              placeholder="请选择"
              @change="deptChange"
              filterable
              :loading="deptLoading"
            >
              <el-option v-for="item in deptList" :key="item.expeDeptCode" :label="item.expeDeptName+ ' ' + item.expeDeptCode" :value="item.expeDeptCode" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="查看人" prop="userId">
            <el-select
              v-model="formData.userId"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="userRemoteMethod"
              @change="userChange"
              :loading="userLoading"
            >
              <el-option v-for="item in userList" :key="item.userId" :label="item.combination" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { budgetPerformancePermissionApi, expensesJurManagementApi } from '../../service';

export default {
  data () {
    return {
      rules: {
        deptCode: [
          { required: true, message: '请选择费用部门名称', trigger: 'change' }
        ],
        userId: [
          { required: true, message: '请选择查看人', trigger: 'change' }
        ]
      },
      dialogTitle: '添加',
      dialogVisible: false,
      formData: {
        deptCode: '',
        deptName: '',
        userId: '',
        userName: ''
      },
      deptList: [],
      userList: [],
      deptLoading: false,
      userLoading: false
    };
  },
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    addDialogVisible (val) {
      if (val) {
        this.dialogTitle = this.rowData.id ? '编辑' : '添加';
        this.getDeptList();
        if (this.rowData.id) {
          this.formData = {
            id: this.rowData.id,
            deptCode: this.rowData.deptCode || this.rowData.departmentCode || '',
            deptName: this.rowData.deptName || this.rowData.departmentName || '',
            userId: this.rowData.userId || '',
            userName: this.rowData.userName || this.rowData.viewer || ''
          };
          if (this.formData.userName) {
            this.userRemoteMethod(this.formData.userName);
          }
        } else {
          this.resetFormData();
        }
      } else {
        this.resetFormData();
        this.deptList = [];
        this.userList = [];
        this.$nextTick(() => {
          if (this.$refs.budgetPerformancePermissionForm) {
            this.$refs.budgetPerformancePermissionForm.clearValidate();
          }
        });
      }
      this.$nextTick(() => {
        this.dialogVisible = val;
      });
    }
  },
  methods: {
    resetFormData () {
      this.formData = {
        deptCode: '',
        deptName: '',
        userId: '',
        userName: ''
      };
    },
    getDeptList () {
      this.deptLoading = true;
      expensesJurManagementApi.getExpenseDeptList().then(res => {
        if (res.status === '200') {
          this.deptList = res.data || [];
        }
        this.deptLoading = false;
      });
    },
    userRemoteMethod (query) {
      if (query && query.indexOf(' ') === -1) {
        this.userLoading = true;
        budgetPerformancePermissionApi.getAllSalesmanList(query).then(res => {
          if (res.status === '200') {
            this.userList = (res.data || []).map(item => {
              return {
                ...item,
                combination: `${item.userName}/${item.deptName}`
              };
            });
          }
          this.userLoading = false;
        });
      } else {
        this.userList = [];
      }
    },
    deptChange (val) {
      const targetDept = this.deptList.find(item => item.expeDeptCode === val);
      this.formData.deptName = targetDept ? targetDept.expeDeptName : '';
    },
    userChange (val) {
      const targetUser = this.userList.find(item => item.userId === val);
      this.formData.userName = targetUser ? targetUser.userName : '';
    },
    submitHandlen () {
      this.$refs.budgetPerformancePermissionForm.validate(valid => {
        if (valid) {
          const params = {
            userId: this.formData.userId,
            userName: this.formData.userName,
            deptCode: this.formData.deptCode,
            deptName: this.formData.deptName
          };
          if (this.formData.id) {
            this.$emit('editBudgetPerformancePermissionHandle', {
              ...params,
              id: this.formData.id
            });
          } else {
            this.$emit('addBudgetPerformancePermissionHandle', params);
          }
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style scoped>
.addBudgetPerformancePermissionDialog ::v-deep .el-input,
.addBudgetPerformancePermissionDialog ::v-deep .el-select {
  width: 100%;
}
</style>
